import _ from "lodash";

const ScheduleHeader = (props) => {
  const roomHeaders = () => {
    return _.chain(props.rooms)
      .sortBy((room) => room.number)
      .map((room) => (
        <th key={`room${room.number}-header`} className="schedule-header">
          <a href={room.url}>{room.name}</a>
          <br />
          <span>{room.subject}</span>
        </th>
      ))
      .value();
  };

  return (
    <thead>
      <tr>
        <th className="sticky-col" />
        {roomHeaders(props.rooms)}
      </tr>
    </thead>
  );
};

export default ScheduleHeader;
